import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { CalendarModule, DateAdapter } from "angular-calendar";
import { adapterFactory } from "angular-calendar/date-adapters/date-fns";
import { MatTooltipModule } from '@angular/material/tooltip';

import { SharedModule } from "@shared/shared.module";
import { routing } from "./clientes.routing";

//paginas
import { VisaoCidadeComponent } from "./pages/visao-cidade/visao-cidade.component";
import { ClienteMovimentacaoComponent } from "./pages/cliente-movimentacao/cliente-movimentacao.component";
import { CarteiraPedidoComponent } from "./pages/carteira-pedido/carteira-pedido.component";
import { DebitosAbertoComponent } from "./pages/debitos-aberto/debitos-aberto.component";
import { EspelhoPedidoComponent } from "./pages/espelho-pedido/espelho-pedido.component";
import { AcompanharLancamentoSetorComponent } from './pages/acompanhar-lancamento-setor/acompanhar-lancamento-setor.component'
import { PrevisaoVendasComponent } from './pages/previsao-vendas/previsao-vendas.component';
import { CarteiraClientesComponent } from './pages/carteira-clientes/carteira-clientes.component';
import { EspelhoPdfComponent } from "./pages/espelho-pdf/espelho-pdf.component";

import { ClientesService } from "./services/clientes.service";
import { VendasService } from "./services/vendas.service";
import { LocationsService } from './services/locations.service';

import { CarteiraFuturaModalComponent } from './modals/carteira-futura-modal/carteira-futura-modal.component';
import { MostruarioIdealModalComponent } from './modals/mostruario-ideal-modal/mostruario-ideal-modal.component';
import { HistoricSalesModalComponent } from './modals/historic-sales-modal/historic-sales-modal.component';

import { RootComponent } from "./root/root.component";
import { HistoricSectionComponent } from './components/historic-modal-section/historic-modal-section.component';
import { SelecionarPeriodoPrevisaoLancamentoComponent } from './components/selecionar-periodo-previsao-lancamento/selecionar-periodo-previsao-lancamento.component';
import { HistoricoRecepcaoTransmissaoComponent } from './pages/historico-recepcao-transmissao/historico-recepcao-transmissao.component';
import { LiberarDigitacaoTrcComponent } from './pages/liberar-digitacao-trc/liberar-digitacao-trc.component';
import { RelatorioVendasComponent } from './pages/relatorio-vendas/relatorio-vendas.component';
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    routing,
    SharedModule,
    BrowserAnimationsModule,
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory
    }),
    MatTooltipModule
  ],
  declarations: [
    RootComponent,
    VisaoCidadeComponent,
    ClienteMovimentacaoComponent,
    CarteiraPedidoComponent,
    DebitosAbertoComponent,
    EspelhoPedidoComponent,
    AcompanharLancamentoSetorComponent,
    CarteiraClientesComponent,
    SelecionarPeriodoPrevisaoLancamentoComponent,
    PrevisaoVendasComponent,
    CarteiraFuturaModalComponent,
    MostruarioIdealModalComponent,
    HistoricSectionComponent,
    HistoricSalesModalComponent,
    EspelhoPdfComponent,
    HistoricoRecepcaoTransmissaoComponent,
    LiberarDigitacaoTrcComponent,
    RelatorioVendasComponent
  ],
  providers: [ClientesService, VendasService, LocationsService]
})
export class ClientesModule {}
